<template>
  <div id="app-div" style="overflow-y: hidden">
    <div class="top">
      <div class="search_icon">
        <span style="margin-left: 10px">
          <img src="../../../../assets/u3220.png" class="icon_img" />
          筛选查询
        </span>
      </div>
      <div class="query_div">
        <a-row>
          <a-col :span="5">
            <label>年份：</label>
            <a-select class="query_input" v-model="queryYear">
              <a-select-option value="0">请选择</a-select-option>
              <a-select-option
                v-for="item in yearList"
                :key="item"
                :value="item"
                >{{ item }}</a-select-option
              >
            </a-select>
          </a-col>
          <a-button type="primary" class="query_btn" @click="query"
            >查询</a-button
          >
          <a-button
            type="primary"
            style="margin-left: 10px"
            @click="() => addMethod('add')"
            >新增</a-button
          >
        </a-row>
      </div>
    </div>
    <div class="middle">
      <div style="float: left; margin-left: 10px">
        <img src="../../../../assets/u3227.png" class="icon_img" />
        <span>&nbsp;数据列表</span>
      </div>
      <div class="sortType" style="float: right">
        排序方式：
        <a-select
          size="small"
          defaultValue="1"
          style="width: 120px"
          @change="sortChange"
          v-model="sort"
        >
          <a-select-option value="1">编号降序</a-select-option>
          <a-select-option value="2">编号升序</a-select-option>
          <a-select-option value="3">时间降序</a-select-option>
          <a-select-option value="4">时间升序</a-select-option>
        </a-select>
      </div>
    </div>
    <div class="bottom" id="bottom">
      <div class="table_box">
        <a-table
          :pagination="false"
          :rowSelection="rowSelection"
          :columns="columns"
          :dataSource="data"
          :rowKey="(record) => record.planCode"
          size="small"
          :scroll="{ y: data.length < 8 ? false : table_height }"
          bordered
        >
          <span slot="operator" slot-scope="text, record">
            <a
              href="javascript:void(0);"
              @click="() => checkMethod(record, 'check')"
              >查看</a
            >
            <a-divider type="vertical" />
            <a
              href="javascript:void(0);"
              @click="() => editMethod(record, 'edit')"
              >编辑</a
            >
            <a-divider type="vertical" />
            <a
              href="javascript:void(0);"
              @click="() => addPeriodical(record, 'addPeriodical')"
              >增刊</a
            >
            <a-divider type="vertical" />
            <a
              href="javascript:void(0);"
              @click="() => changeStatus(record, '1')"
              >启用</a
            >
            <a-divider type="vertical" />
            <a
              href="javascript:void(0);"
              @click="() => changeStatus(record, '0')"
              >禁用</a
            >
            <a-divider type="vertical" />
            <a
              href="javascript:void(0);"
              @click="() => deleteMethod(record.planCode)"
              >删除</a
            >
          </span>
          <span slot="status" slot-scope="text, record">
            <label v-if="record.status == '1'">
              <img class="status_img" src="../../../../assets/open.png" />已启用
            </label>
            <label v-if="record.status == '0'">
              <img
                class="status_img"
                src="../../../../assets/close.png"
              />已禁用
            </label>
          </span>
          <span slot="count" slot-scope="text, record">
            <label>第{{ record.count }}期</label>
          </span>
          <span slot="total" slot-scope="text, record">
            <label>总第{{ record.total }}期</label>
          </span>
        </a-table>
      </div>
      <div id="components-pagination-demo-mini">
        <a-pagination
          :total="total"
          :showTotal="(total) => `共 ${total} 条`"
          showSizeChanger
          showQuickJumper
          :pageSizeOptions="pageSizeOptions"
          :defaultPageSize="limit"
          @showSizeChange="onShowSizeChange"
          @change="pageChange"
        />
      </div>
      <a-select
        defaultValue="0"
        class="batch_operation"
        @change="operateChange"
        v-model="operateCode"
      >
        <a-select-option value="0">批量操作</a-select-option>
        <a-select-option value="1">批量导出</a-select-option>
        <a-select-option value="2">批量禁用</a-select-option>
        <a-select-option value="3">批量启用</a-select-option>
      </a-select>
    </div>
    <a-modal
      :title="title"
      v-model="visible"
      width="600px"
      @cancel="cancel"
      @ok="enSure"
      :centered="true"
      :maskClosable="false"
    >
      <template>
        <div class="plan-edit">
          <a-row>
            <a-col :span="6" class="title">期刊名称：</a-col>
            <a-col :span="12">
              <a-input
                placeholder="请输入"
                class="input"
                v-model="publishPlan.periodicalName"
                v-bind:read-only="true"
              />
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="6" class="title">期刊周期：</a-col>
            <a-col :span="12">
              <a-input
                placeholder="请输入"
                class="input"
                v-model="publishPlan.cycle"
                v-bind:read-only="true"
              />
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="6" class="title">
              <span style="color: red">*</span>计划年份：
            </a-col>
            <a-col :span="12">
              <a-input
                placeholder="请输入"
                class="input"
                v-model="publishPlan.year"
                v-bind:read-only="isEnable"
              />
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="6" class="title">
              <span style="color: red">*</span>基准总期数：
            </a-col>
            <a-col :span="12">
              <label>总第</label>
              <a-input
                placeholder="请输入"
                class="input"
                v-model="publishPlan.total"
                v-bind:read-only="isEnable"
                style="margin: 0 10px; width: 100px"
              />
              <label>期</label>
            </a-col>
          </a-row>
        </div>
      </template>
    </a-modal>

    <a-modal
      title="查看"
      v-model="checkVisible"
      width="600px"
      :footer="null"
      :centered="true"
      :maskClosable="false"
    >
      <template>
        <div class="plan-edit">
          <a-row>
            <a-col :span="12" class="title">期刊名称：</a-col>
            <a-col :span="12" style="margin-top: 5px">
              <label>{{ publishPlan.periodicalName }}</label>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="12" class="title">期刊周期：</a-col>
            <a-col :span="12" style="margin-top: 5px">
              <label>{{ publishPlan.cycle }}</label>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="12" class="title"> 计划年份： </a-col>
            <a-col :span="12" style="margin-top: 5px">
              <label>{{ publishPlan.year }}</label>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="12" class="title"> 基准总期数： </a-col>
            <a-col :span="12" style="margin-top: 5px">
              <label>总第{{ publishPlan.total }}期</label>
            </a-col>
          </a-row>
        </div>
      </template>
    </a-modal>
    <a-modal
      title="提示"
      v-model="delVisible"
      @ok="deleteOk"
      :centered="true"
      :maskClosable="false"
      width="300px"
    >
      <p>确认删除吗？</p>
    </a-modal>
  </div>
</template>


<script>
//import checkRole from "./../components/checkRole";
import moment from "moment";
const columns = [
  {
    title: "年份",
    dataIndex: "year",
  },
  {
    title: "期次描述",
    dataIndex: "count",
    scopedSlots: { customRender: "count" },
  },
  {
    title: "总期次",
    dataIndex: "total",
    scopedSlots: { customRender: "total" },
  },
  {
    title: "状态",
    dataIndex: "status",
    scopedSlots: { customRender: "status" },
  },
  {
    title: "创建者",
    dataIndex: "creater",
  },
  {
    title: "创建时间",
    dataIndex: "createTime",
  },
  {
    title: "操作",
    width: 280,
    key: "operator",
    scopedSlots: { customRender: "operator" },
  },
];

const data = [];

import qs from "qs";
export default {
  name: "publishPlan",
  components: {
    // "check-role":checkRole
  },
  data() {
    return {
      serviceAddress: this.$config.serviceAddress,
      data,
      columns,
      selectedRowKeys: [],
      visible: false,
      checkVisible: false,
      publishPlan: { year: "", total: "" },
      periodicalDoc: {},
      isEnable: false,
      title: "查看",
      currentMode: "check",
      delVisible: false,
      queryYear: "0",
      yearList: [],
      delPlanCode: "",
      sort: "1",
      sortField: "total",
      sortType: "desc",
      operateCode: "0",
      value: 1,
      page: 1,
      limit: 20,
      total: 0,
      pageSizeOptions: ["10", "20", "30", "40", "50"],
      table_height: 0,
    };
  },
  computed: {
    rowSelection() {
      const { selectedRowKeys } = this;
      return {
        columnWidth: 35,
        selectedRowKeys,
        onChange: this.onSelectChange,
        hideDefaultSelections: true,
        onSelection: this.onSelection,
      };
    },
  },
  created() {
    this.query();
    this.queryPeriodical();

    this.axios.get("/publishPlan/queryYear").then((res) => {
      this.yearList = res.data;
    });
  },
  mounted() {
    //设置bottom高度
    var height = document.body.clientHeight;
    var bottom_height = height - 230;
    var bottom = document.getElementById("bottom");
    bottom.style.height = bottom_height + "px";
    this.table_height = bottom_height - 100;
  },
  methods: {
    moment,
    onShowSizeChange(current, pageSize) {
      this.page = current;
      this.limit = pageSize;
      this.query();
    },
    pageChange(pageNumber) {
      this.page = pageNumber;
      this.query();
    },
    sortChange() {
      if (this.sort == 1) {
        this.sortField = "total";
        this.sortType = "desc";
      } else if (this.sort == 2) {
        this.sortField = "total";
        this.sortType = "";
      } else if (this.sort == 3) {
        this.sortField = "create_time";
        this.sortType = "desc";
      } else if (this.sort == 4) {
        this.sortField = "create_time";
        this.sortType = "";
      }
      this.query();
    },
    operateChange() {
      var itemLegth = this.selectedRowKeys.length;
      if (itemLegth == 0) {
        this.utils.messageInfo(this, "error", "最少选择一条数据！");
        return;
      }
      if (this.operateCode == 1) {
        if (this.serviceAddress == "") {
          this.utils.messageInfo(
            this,
            "error",
            "获取后台ip地址失败，无法导出！"
          );
          return;
        }
        var selectedRowKeys = this.selectedRowKeys;
        window.open(
          this.serviceAddress +
            "/publishPlan/exportData?codeArr=" +
            selectedRowKeys +
            ""
        );
      } else if (this.operateCode == 2) {
        this.batchChangeStatus("0");
      } else if (this.operateCode == 3) {
        this.batchChangeStatus("1");
      }
    },

    batchChangeStatus(status) {
      this.axios
        .post("/publishPlan/changeStatus", {
          status: status,
          codes: JSON.stringify(this.selectedRowKeys),
        })
        .then((res) => {
          if (res.data.code == "OK") {
            if (status == "0") {
              this.utils.messageInfo(this, "success", "禁用成功！");
            } else {
              this.utils.messageInfo(this, "success", "启用成功！");
            }
            this.query();
          } else {
            this.utils.messageInfo(this, "error", "操作失败！");
          }
        });
    },
    statusChange(e) {
      if (e.target.checked) {
        this.columnInfo.status = 1;
      } else {
        this.columnInfo.status = 0;
      }
    },
    query() {
      this.axios
        .get("/publishPlan/queryPublishPlan", {
          params: {
            year: this.queryYear,
            sortField: this.sortField,
            sortType: this.sortType,
            page: this.page,
            limit: this.limit,
            time: new Date().getTime(),
          },
          paramsSerializer: function (p) {
            return qs.stringify(p, { arrayFormat: "repeat" });
          },
        })
        .then((res) => {
          if (res.data.code == "0") {
            this.total = res.data.count;
            this.data = res.data.data;
          } else {
            this.utils.messageInfo(this, "error", "查询栏目列表失败！");
          }
        });
    },
    queryPeriodical() {
      this.axios
        .get("/periodicalDoc/queryPeriodicalDoc", {
          params: {
            time: new Date().getTime(),
          },
          paramsSerializer: function (p) {
            return qs.stringify(p, { arrayFormat: "repeat" });
          },
        })
        .then((res) => {
          if (res.data.code == "OK") {
            this.periodicalDoc = res.data.data;
          } else {
            this.utils.messageInfo(this, "error", "查询期刊档案失败！");
          }
        });
    },
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys;
    },
    addMethod(type) {
      this.publishPlan = {
        year: "",
        total: "",
        periodicalName: this.periodicalDoc.periodicalName,
      };

      var perCycle = this.periodicalDoc.cycle;
      if (perCycle == "year") {
        this.publishPlan.cycle = "全年刊";
      } else if (perCycle == "douMon") {
        this.publishPlan.cycle = "双月刊";
      } else if (perCycle == "month") {
        this.publishPlan.cycle = "月刊";
      } else if (perCycle == "halfMon") {
        this.publishPlan.cycle = "半月刊";
      } else if (perCycle == "xunMon") {
        this.publishPlan.cycle = "旬刊";
      } else if (perCycle == "week") {
        this.publishPlan.cycle = "周刊";
      }

      this.isEnable = false;
      this.visible = true;
      this.title = "新增";
      this.currentMode = type;
    },
    checkMethod(obj) {
      this.publishPlan = obj;
      this.checkVisible = true;
    },
    editMethod(obj, type) {
      this.publishPlan = {
        planCode: obj.planCode,
        periodicalName: obj.periodicalName,
        cycle: obj.cycle,
        year: obj.year,
        total: obj.total,
      };
      this.isEnable = false;
      this.visible = true;
      this.title = "编辑";
      this.currentMode = type;
    },
    addPeriodical(record, type) {
      this.publishPlan = {
        year: record.year,
        total: record.total + 1,
        count: record.count,
      };
      this.isEnable = false;
      this.visible = true;
      this.title = "增刊";
      this.currentMode = type;
    },
    changeStatus(obj, status) {
      var codes = [];
      codes.push(obj.planCode);
      this.axios
        .post("/publishPlan/changeStatus", {
          codes: JSON.stringify(codes),
          status: status,
        })
        .then((res) => {
          if (res.data.code == "OK") {
            if (status == "0") {
              this.utils.messageInfo(this, "success", "禁用成功！");
            } else {
              this.utils.messageInfo(this, "success", "启用成功！");
            }
            for (var i = 0; i < this.data.length; i++) {
              if (this.data[i].planCode == obj.planCode) {
                this.data[i].status = status;
              }
            }
          } else {
            this.utils.messageInfo(this, "error", "编辑失败！");
          }
        });
    },
    deleteMethod(planCode) {
      this.delVisible = true;
      this.delPlanCode = planCode;
    },
    deleteOk() {
      this.axios
        .post("/publishPlan/deletePublishPlan", {
          planCode: this.delPlanCode,
        })
        .then((res) => {
          if (res.data.code == "OK") {
            this.utils.messageInfo(this, "success", "删除成功");
            this.delVisible = false;
            this.query();
          } else {
            this.utils.messageInfo(this, "error", "删除失败！");
          }
        });
    },
    cancel() {
      this.visible = false;
    },
    enSure() {
      var numReg = /(^[1-9]\d*$)/;
      if (this.currentMode == "check") {
        this.visible = false;
      } else if (this.currentMode == "edit") {
        if (this.publishPlan.year == "") {
          this.utils.messageInfo(this, "error", "计划年份不能为空！");
          return;
        } else if (this.publishPlan.total == "") {
          this.utils.messageInfo(this, "error", "基准总期数不能为空！");
          return;
        }

        if (!numReg.test(this.publishPlan.year)) {
          this.utils.messageInfo(this, "error", "计划年份只能输入正整数！");
          return;
        }
        if (!numReg.test(this.publishPlan.total)) {
          this.utils.messageInfo(this, "error", "基准总期数只能输入正整数！");
          return;
        }
        this.axios
          .post("/publishPlan/updatePublishPlan", {
            periodicalName: this.publishPlan.periodicalName,
            cycle: this.publishPlan.cycle,
            year: this.publishPlan.year,
            total: this.publishPlan.total,
            planCode: this.publishPlan.planCode,
          })
          .then((res) => {
            if (res.data.code == "OK") {
              this.utils.messageInfo(this, "success", "编辑成功");
              this.query();
              this.visible = false;
            } else {
              this.utils.messageInfo(this, "error", "编辑失败！");
            }
          });
      } else if (this.currentMode == "add") {
        if (this.publishPlan.year == "") {
          this.utils.messageInfo(this, "error", "计划年份不能为空！");
          return;
        } else if (this.publishPlan.total == "") {
          this.utils.messageInfo(this, "error", "基准总期数不能为空！");
          return;
        }

        if (!numReg.test(this.publishPlan.year)) {
          this.utils.messageInfo(this, "error", "计划年份只能输入正整数！");
          return;
        }
        if (!numReg.test(this.publishPlan.total)) {
          this.utils.messageInfo(this, "error", "基准总期数只能输入正整数！");
          return;
        }
        this.axios
          .post("/publishPlan/savePublishPlan", {
            periodicalName: this.publishPlan.periodicalName,
            status: 1,
            cycle: this.publishPlan.cycle,
            year: this.publishPlan.year,
            total: this.publishPlan.total,
            creater: sessionStorage.getItem("userCode"),
          })
          .then((res) => {
            if (res.data.code == "OK") {
              this.utils.messageInfo(this, "success", "添加成功");
              this.query();
              this.visible = false;
            } else {
              this.utils.messageInfo(this, "error", "添加失败！");
            }
          });
      } else if (this.currentMode == "addPeriodical") {
        if (this.publishPlan.year == "") {
          this.utils.messageInfo(this, "error", "计划年份不能为空！");
          return;
        } else if (this.publishPlan.total == "") {
          this.utils.messageInfo(this, "error", "基准总期数不能为空！");
          return;
        }

        if (!numReg.test(this.publishPlan.year)) {
          this.utils.messageInfo(this, "error", "计划年份只能输入正整数！");
          return;
        }
        if (!numReg.test(this.publishPlan.total)) {
          this.utils.messageInfo(this, "error", "基准总期数只能输入正整数！");
          return;
        }
        this.axios
          .post("/publishPlan/addPeriodical", {
            periodicalName: this.publishPlan.periodicalName,
            status: 1,
            cycle: this.publishPlan.cycle,
            year: this.publishPlan.year,
            total: this.publishPlan.total,
            count: this.publishPlan.count,
            creater: sessionStorage.getItem("planCode"),
          })
          .then((res) => {
            if (res.data.code == "OK") {
              this.utils.messageInfo(this, "success", "添加成功");
              this.query();
              this.visible = false;
            } else {
              this.utils.messageInfo(this, "error", "添加失败！");
            }
          });
      }
    },
  },
};
</script>
<style>
@import "../../../../assets/css/PageCss.css";
</style>
<style scoped>
.plan-edit .ant-row {
  margin-bottom: 10px;
}
.plan-edit .title {
  text-align: right;
  line-height: 32px;
}
.status_img {
  width: 18px;
  margin-right: 6px;
  margin-bottom: 3px;
}
</style>
